import React from "react";
import { useTranslation } from "react-i18next";
// Components
import {
  TreatmentDiv,
  TitleTextDiv,
  TreatmentText,
  TreatmentInputDiv,
  Label,
  InputCheckboxDiv,
  InputCheckbox,
  VerifyCheckboxImg,
} from "./styles";
// Assets
import CheckTrue from "../../../../assets/ico_checkbox_true.svg";
import CheckFalse from "../../../../assets/ico_checkbox_false.svg";

const Terms = ({ terms, setTerms, termsError, setTermsError }) => {
  const [t] = useTranslation("global");

  const handleSetTerms = () => {
    setTermsError(false);
    if (!terms) {
      setTerms(true);
    } else {
      setTerms(false);
    }
  };

  return (
    <TreatmentDiv>
      <TitleTextDiv>
        <p>{t("addPatient.personalDataTreatmentTitle")}</p>
      </TitleTextDiv>
      <TreatmentText>{t("addPatient.personalDataTreatmentText")}</TreatmentText>
      <TreatmentInputDiv>
        <Label htmlFor="conditions" fontWeight="bold">
          {t("addPatient.conditions")} *
        </Label>
        <InputCheckboxDiv error={termsError}>
          <InputCheckbox type="checkbox" id="conditions" value={terms} onChange={handleSetTerms} />
          {terms ? (
            <VerifyCheckboxImg src={CheckTrue} alt="check-true" />
          ) : (
            <VerifyCheckboxImg src={CheckFalse} alt="check-false" />
          )}
        </InputCheckboxDiv>
      </TreatmentInputDiv>
    </TreatmentDiv>
  );
};

export default Terms;
